import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=cf2280b6&scoped=true&"
import script from "./ImageViewer.vue?vue&type=script&lang=js&"
export * from "./ImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=cf2280b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2280b6",
  null
  
)

export default component.exports